export const CSRF_TOKEN_HEADER_PROPERTY = 'x-csrf-token';
